import api from "@/components/customAxios/Axios";
import { useEffect } from "react";
import { useLoader } from "@/context/loaderContext";
import { useToast } from "../components/toast";

const AssessmentTermination = () => {
	const { setLoading } = useLoader();
	const toast = useToast();
	const sendAssessmentTerminationEmail = async () => {
		try {
			setLoading(true);
			const response = await api.post(
				"/terminate_assessment_due_to_screen_switch_mail",
				{
					candidate_id: JSON.parse(sessionStorage.getItem("question") || "{}")
						?.candidate_id,
				}
			);

			if (response.status == 200) {
				sessionStorage.clear();
				localStorage.clear();
				window.location.reload()
			}
		} catch (error: any) {
			toast.error({
				title: "Assessment Terminated",
				description: error.response?.data?.message || error.response?.data?.error || "Something went wrong.",
				duration: 5000,
				open: true,
				status: "Error",
			});
		} finally {
			setLoading(false);
		}
	};

	useEffect(() => {
		sendAssessmentTerminationEmail();
	}, []);
	return (
		<div>
			<div className="fixed top-0 left-0 w-full h-full flex items-center justify-center bg-black bg-opacity-50 dark:bg-opacity-50 z-50">
				<div className="bg-white dark:bg-zinc-800 rounded-lg p-8 max-w-md">
					<h2 className="text-2xl font-bold text-center text-red-600  mb-4">
						Assessment Terminated
					</h2>
					<p className="text-zinc-700 dark:text-zinc-300 text-center">
						Your assessment is terminated as you have exceeded the tab switch
						limit.
					</p>
				</div>
			</div>
		</div>
	);
};

export default AssessmentTermination;
